import { createReducer } from '@mhub/web-redux-utilities';
import Types from './types';

const initialState = {
  loading: false,
  statusText: null,
  isError: false,
  data: [],
  pagination: {},
  token: null,
  companyID: null,
};

export default createReducer(initialState, {
  [Types.PROJECTS_SET_LOADING]: (state, payload) => (
    Object.assign({}, state, {
      loading: payload.loading,
    })
  ),
  [Types.PROJECTS_REQUEST]: state => (
    Object.assign({}, state, {
      loading: true,
      isError: false,
      statusText: null,
    })
  ),
  [Types.PROJECTS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      data: payload.pagination.offset === 0 ? payload.data : state.data.concat(payload.data),
      pagination: payload.pagination,
      token: payload.token,
      companyID: payload.companyID,
    })
  ),
  [Types.PROJECTS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      isError: true,
      statusText: payload.statusText,
    })
  ),
  [Types.PROJECTS_RESET]: () => Object.assign({}, initialState),
});
